// extracted by mini-css-extract-plugin
export var wordContainer = "_lw-0";